import api from "../axiosIntercepture";

export const getallusers = async (userData) => {
    try {
        const response = await api.post("auth/getallusers",);
        return response.data?.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
}
